import {
    Container,
    Typography,
    Box,
    Stack,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import SchoolLeaderboardTable from "../../sections/schooLeaderboard/SchoolLeaderboardTable";
import SchoolLeaderboardSection from "../../sections/schooLeaderboard/SchoolLeaderboardSection";
import SchoolLeaderboardQueryForm from "../../sections/schooLeaderboard/SchoolLeaderboardQueryForm";

// Sample skill record data
const skillRecord = {
    id: 42,
    name_zh: "可信Jumping Jack",
    name_en: "Hoshun Jump Jack",
    code: "hoshun_jumping_jack",
    fitness_type: "hoshun_jumping_jack",
    fitness_type_en: "Hoshun Jump Jack",
    fitness_type_zh: "可信Jumping Jack",
    unit: "score",
    decimal_place: 0,
    rank_direction: "desc",
    support_ipad: true,
    color: "blue",
    result: [
        {
            rank: 1,
            score: "22",
            unit: "",
            participants: [
                { type: "member", member_id: "18357", name: "趙 焌 傑", school_cls: "2B" },
                { type: "member", member_id: "18713", name: "劉 嘉 妍", school_cls: "5A" },
                { type: "member", member_id: "18842", name: "趙 芷 雯", school_cls: "4B" }
            ]
        },
        {
            rank: 2,
            score: "21",
            unit: "",
            participants: [
                { type: "member", member_id: "18371", name: "陸 宇 軒", school_cls: "2B" },
                { type: "member", member_id: "18397", name: "簡 梓 雅", school_cls: "2C" }
            ]
        },
        {
            rank: 3,
            score: "20",
            unit: "",
            participants: [
                { type: "member", member_id: "18795", name: "羅 梓 瑜", school_cls: "5D" }
            ]
        },
        {
            rank: 4,
            score: "19",
            unit: "",
            participants: [
                { type: "member", member_id: "18467", name: "陳 詩 妍", school_cls: "3B" },
                { type: "member", member_id: "18484", name: "孫 銘 浩", school_cls: "3B" }
            ]
        },
        {
            rank: 5,
            score: "18",
            unit: "",
            participants: [
                { type: "member", member_id: "18763", name: "何 紫 慧", school_cls: "5C" },
                { type: "member", member_id: "18885", name: "馬 福 熙", school_cls: "4D" }
            ]
        },
        {
            rank: 6,
            score: "17",
            unit: "",
            participants: [
                { type: "member", member_id: "18489", name: "王 梓 蕘", school_cls: "3B" },
                { type: "member", member_id: "18840", name: "陳 彥 羽", school_cls: "4B" },
                { type: "member", member_id: "18891", name: "黃 凱 婷", school_cls: "4D" }
            ]
        }
    ]
};

export default function TestSchoolLeaderboardSection() {
    const { t } = useTranslation();
    const [value, setValue] = React.useState(1234);

    React.useEffect(() => {
        setValue(1234);
    }, []);

    let lang = getLang();

    // setValue(1234);

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">Test School Leaderboard</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                    <pre>Value: {value} </pre>

                </Box>

                {/* <SchoolLeaderboardQueryForm onQuery={({mode, filters}) => {
                    console.debug("Query: ", {mode, filters});
                }} /> */}

                <SchoolLeaderboardSection orgID={129} />
                {/* <SchoolLeaderboardTable leaderboardSkillRecord={skillRecord}/> */}
            </Stack>
        </Container>
    )
}
